<template>
    <div class="container-fluid px-0">
      <div class="row mb-4 g-2" style="margin-right: 4%;">
        <div class="col-md-3">
          <select 
            class="form-select" 
            v-model="statusFilter" 
            @change="handleStatusFilter"
          >
            <option value="">كل الحالات</option>
            <option value="active">نشط</option>
            <option value="inactive">غير نشط</option>
          </select>
        </div>
        
        <div class="col-md-3">
          <select 
            class="form-select" 
            v-model="chapterFilter" 
            @change="handleChapterFilter"
          >
            <option value="">كل الابواب</option>
            <option 
              v-for="chapter in chapters" 
              :key="chapter.id" 
              :value="chapter.id"
            >
              {{ chapter.name }}
            </option>
          </select>
        </div>
        
        <div class="col-md-3">
          <select 
            class="form-select" 
            v-model="subjectFilter" 
            @change="handleSubjectFilter"
          >
            <option value="">كل المواد</option>
            <option 
              v-for="subject in subjects" 
              :key="subject.id" 
              :value="subject.id"
            >
              {{ subject.name }}
            </option>
          </select>
        </div>
        
        <div class="col-md-1">
          <button 
            class="btn btn-outline-secondary w-100" 
            @click="resetFilters"
            title="إعادة الضبط"
          >
            <i class="fas fa-filter-circle-xmark"></i>
          </button>
        </div>
        
        <div class="col-md-2">
          <button class="btn btn-secondary w-100" @click="$emit('add')">
            <i class="fas fa-plus"></i>
            إضافة جديد
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, defineEmits } from 'vue';
  import api from '@/api';
  
  const statusFilter = ref('');
  const chapterFilter = ref('');
  const subjectFilter = ref('');
  const chapters = ref([]);
  const subjects = ref([]);
  
  const emit = defineEmits(['status', 'chapter', 'subject', 'add', 'reset']);
  
  onMounted(async () => {
    try {
      const [chaptersRes, subjectsRes] = await Promise.all([
        api.get('/chapters'),
        api.get('/subjects')
      ]);
      chapters.value = chaptersRes.data.data;
      subjects.value = subjectsRes.data.data;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  });
  
  const handleStatusFilter = () => {
    emit('status', statusFilter.value);
  };
  
  const handleChapterFilter = () => {
    emit('chapter', chapterFilter.value);
  };
  
  const handleSubjectFilter = () => {
    emit('subject', subjectFilter.value);
  };
  
  const resetFilters = () => {
    statusFilter.value = '';
    chapterFilter.value = '';
    subjectFilter.value = '';
    emit('reset');
  };
  </script>